import Link from "next/link";
import React from "react";
import SiteShell from "@/components/SiteShell";
import { INTEGRATIONS } from "./[slug]";

/** Integrations hub (www.frazzlecrm.com/integrations) — indexable. */
export default function IntegrationsIndex() {
  const groups = ["SMTP (email)", "SMS", "Webhooks"] as const;
  return (
    <SiteShell
      title="Integrations — connect your senders and apps to FrazzleCRM"
      description="Connect FrazzleCRM to Mailgun, Amazon SES, SendGrid, Postmark, Brevo (SMTP), Twilio (SMS), and any app via webhooks (Stripe, Shopify, Cal.com). Bring your own credentials — sending at provider cost, no markup."
    >

      <section className="bg-gradient-to-b from-indigo-50/60 to-white">
        <div className="mx-auto max-w-4xl px-6 pb-10 pt-16 text-center">
          <h1 className="text-[36px] font-extrabold leading-[1.12] tracking-tight text-slate-900 sm:text-[44px]">
            Your providers.{" "}
            <span className="bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
              Your rates.
            </span>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-[15.5px] leading-relaxed text-slate-600">
            FrazzleCRM sends through credentials you own — your domain, your
            provider pricing, zero markup. Pick a guide:
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-20">
        {groups.map((g) => (
          <div key={g} className="mb-8">
            <h2 className="text-[13px] font-bold uppercase tracking-widest text-slate-400">
              {g}
            </h2>
            <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {INTEGRATIONS.filter((i) => i.kind === g).map((i) => (
                <Link
                  key={i.slug}
                  href={`/integrations/${i.slug}`}
                  className="group rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-shadow hover:shadow-md"
                >
                  <h3 className="text-[16px] font-bold text-slate-900 group-hover:text-indigo-700">
                    {i.name}
                  </h3>
                  <p className="mt-1.5 text-[13px] leading-relaxed text-slate-600">
                    {i.tagline}
                  </p>
                  <span className="mt-2 inline-block text-[12.5px] font-semibold text-indigo-600">
                    Setup guide →
                  </span>
                </Link>
              ))}
            </div>
          </div>
        ))}
        <p className="text-center text-[13px] text-slate-500">
          Anything with an API can also drive FrazzleCRM through the{" "}
          <Link href="/ai" className="font-medium text-indigo-600 hover:text-indigo-500">
            MCP server
          </Link>
          .
        </p>
      </section>
    </SiteShell>
  );
}
